export enum ConnectionTypes {
  patientToDoctor = 'PatientToDoctor',
  doctorToPatient = 'DoctorToPatient',
  addSubAdvisor = 'AddSubAdvisor'
}